import * as React from 'react';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import {
    FormControl,
    FormGroup,
    FormLabel,
    Grid,
    InputLabel,
    Stack,
    TextField,
    Typography,
} from '@mui/material';
import {
    // AppOutlinedRadioInput,
    AppPrimaryButton,
    AppFormikTextArea,
    AppFormikSelect,
    AppFormikDatePicker,
    AppFormikTextField,
    // AppFormikRadioGroup,
} from 'shared/components/AppComponents';
// import { SwitchComp } from 'shared/components/Switch';
import { ClientService } from 'services';
import { useLocation } from 'react-router-dom';
import { RawData } from '../../listing-packets/components/VirtualizedTable';
import {
    ManagePacketService,
    ReworkDocumentRequest,
} from 'services/ManagePacketService';
import { FieldArray, Formik, FormikProps, useFormikContext } from 'formik';
import {
    FormikPropsFixPacketValues,
    NotExpectedMeta,
} from '../NotExpectedPage';
import { Toast, Utils } from 'shared/helpers';
import { areWeTestingWithJest } from 'test/helpers/formik';
import { createDateAsUTC } from 'shared/helpers/AgeOfDate';

import { NotExpectedPacketScheme } from 'validators/SinglePacketScheme';
import { AxiosError } from 'axios';

const ReworkBulkModal: React.FC<BulkReworkModalProps> = React.forwardRef(
    (
        {
            callbackClosingModal,
            callbackOpenModal,
            documents,
            callbackSavingModal,
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            missingDocuments,
            duplicationDocuments,
            datepickerRework,
            clientId,
            packetId,
        },
        ref
    ): React.ReactElement => {
        const { getFieldHelpers, initialValues } =
            useFormikContext<FormikPropsFixPacketValues>();
        const NotExpectedMetaProps = React.useContext(NotExpectedMeta);
        const location = useLocation();
        // const [predefinedMessage, setPredefinedMessage] =
        //     React.useState<string>('');
        // const [, setPredefined] = React.useState<string>('');
        const innerFormik =
            React.useRef<FormikProps<FormikPropsBulkReworkModal> | null>(null);
        const [Solicitors, SetSolicitors] = React.useState<string[]>([]);
        const [SolicitorsData, SetSolicitorsData] = React.useState<
            SolicitorData[]
        >([]);

        const [SolicitorDisplayed, SetSolicitorDisplayed] =
            React.useState<SolicitorData>();
        const [open, setOpen] = React.useState(false);

        const [isSaved, SetDetailSaved] = React.useState<boolean>(false);
        const [openDetailTextArea] = React.useState(true);

        /**
         * handle open modal
         */
        const handleOpen = React.useCallback((): void => {
            setOpen(true);
            if (typeof callbackOpenModal === 'function') callbackOpenModal();
        }, [callbackOpenModal]);

        /**
         * handle close modal
         */
        const handleClose = React.useCallback((): void => {
            if (!isSaved) {
                setOpen(false);
                if (typeof callbackClosingModal === 'function') {
                    callbackClosingModal(null);
                }
            }
        }, [callbackClosingModal, isSaved]);

        /**
         * handle closing rework after successful send a request
         */
        const handleCloseRework = React.useCallback((): void => {
            NotExpectedMetaProps?.setActiveBackNavigation(true);
            if (typeof callbackSavingModal === 'function') {
                callbackSavingModal(null);
            }
        }, [NotExpectedMetaProps, callbackSavingModal]);

        const [isConfirmProceeding, setConfirmProceeding] =
            React.useState<boolean>(false);
        /**
         * handle confirm
         */
        const handleConfirm = React.useCallback(
            async (values: FormikPropsBulkReworkModal) => {
                setConfirmProceeding(true);

                if (
                    innerFormik &&
                    innerFormik.current &&
                    SolicitorsData.some(
                        (o) => `${o.name} - ${o.email.id}` === values.solicitor
                    )
                ) {
                    const solicitor = SolicitorsData.find(
                        (o) => `${o.name} - ${o.email.id}` === values.solicitor
                    );
                    if (solicitor) {
                        // eslint-disable-next-line no-underscore-dangle
                        const _documents: ReworkDocumentRequest[] = Array.from(
                            values.documents
                        )
                            .filter((d) => d.sendToRework === true)
                            .map((document, d) => {
                                const {
                                    // eslint-disable-next-line @typescript-eslint/no-unused-vars
                                    placeholder: b,
                                    _id: documentId,
                                    // eslint-disable-next-line @typescript-eslint/no-unused-vars
                                    processedFile: ps,
                                    // eslint-disable-next-line @typescript-eslint/no-unused-vars
                                    actions: noaction,
                                    // eslint-disable-next-line @typescript-eslint/no-unused-vars
                                    group: g,
                                    // eslint-disable-next-line @typescript-eslint/no-unused-vars
                                    groupName: gi,
                                    // eslint-disable-next-line @typescript-eslint/no-unused-vars
                                    allowReplaceDocument: ar,
                                    // eslint-disable-next-line @typescript-eslint/no-unused-vars
                                    unexpectedFileType: x,
                                    // eslint-disable-next-line @typescript-eslint/no-unused-vars
                                    groups: gx,
                                    // eslint-disable-next-line @typescript-eslint/no-unused-vars
                                    isDuplicate: j,
                                    // eslint-disable-next-line @typescript-eslint/no-unused-vars
                                    variation: o,
                                    // eslint-disable-next-line @typescript-eslint/no-unused-vars
                                    sendToRework: so,
                                    // eslint-disable-next-line @typescript-eslint/no-unused-vars
                                    categoryUpdated: cu,
                                    ..._document
                                } = document;
                                return {
                                    ..._document,
                                    documentId,
                                    categoryUpdated:
                                        initialValues.documents.some(
                                            (e, i) =>
                                                d === i &&
                                                e.category !== document.category
                                        ),
                                    isMissingDocument: false,
                                };
                            });
                        // eslint-disable-next-line no-underscore-dangle
                        const _documentsMissing: ReworkDocumentRequest[] =
                            Array.from(values.missingDocuments)
                                .filter((d) => d.sendToRework === true)
                                .map((document) => {
                                    const {
                                        // eslint-disable-next-line @typescript-eslint/no-unused-vars
                                        placeholder: b,
                                        // eslint-disable-next-line @typescript-eslint/no-unused-vars
                                        _id: documentId,
                                        // eslint-disable-next-line @typescript-eslint/no-unused-vars
                                        processedFile: ps,
                                        // eslint-disable-next-line @typescript-eslint/no-unused-vars
                                        actions: noaction,
                                        // eslint-disable-next-line @typescript-eslint/no-unused-vars
                                        group: g,
                                        // eslint-disable-next-line @typescript-eslint/no-unused-vars
                                        groupName: gi,
                                        // eslint-disable-next-line @typescript-eslint/no-unused-vars
                                        allowReplaceDocument: ar,
                                        // eslint-disable-next-line @typescript-eslint/no-unused-vars
                                        unexpectedFileType: x,
                                        // eslint-disable-next-line @typescript-eslint/no-unused-vars
                                        groups: gx,
                                        // eslint-disable-next-line @typescript-eslint/no-unused-vars
                                        isDuplicate: j,
                                        // eslint-disable-next-line @typescript-eslint/no-unused-vars
                                        variation: o,
                                        // eslint-disable-next-line @typescript-eslint/no-unused-vars
                                        sendToRework: so,
                                        // eslint-disable-next-line @typescript-eslint/no-unused-vars
                                        categoryUpdated: cu,
                                        ..._document
                                    } = document;
                                    return {
                                        ..._document,
                                        documentId: null,
                                        isMissingDocument: true,
                                    };
                                });
                        // eslint-disable-next-line no-underscore-dangle
                        const _documentsDuplication: ReworkDocumentRequest[] =
                            Array.from(values.duplicationDocuments)
                                .filter((d) => d.sendToRework === true)
                                .map((document, d) => {
                                    const {
                                        // eslint-disable-next-line @typescript-eslint/no-unused-vars
                                        placeholder: b,
                                        _id: documentId,
                                        // eslint-disable-next-line @typescript-eslint/no-unused-vars
                                        processedFile: ps,
                                        // eslint-disable-next-line @typescript-eslint/no-unused-vars
                                        actions: noaction,
                                        // eslint-disable-next-line @typescript-eslint/no-unused-vars
                                        group: g,
                                        // eslint-disable-next-line @typescript-eslint/no-unused-vars
                                        groupName: gi,
                                        // eslint-disable-next-line @typescript-eslint/no-unused-vars
                                        allowReplaceDocument: ar,
                                        // eslint-disable-next-line @typescript-eslint/no-unused-vars
                                        unexpectedFileType: x,
                                        // eslint-disable-next-line @typescript-eslint/no-unused-vars
                                        groups: gx,
                                        // eslint-disable-next-line @typescript-eslint/no-unused-vars
                                        isDuplicate: j,
                                        // eslint-disable-next-line @typescript-eslint/no-unused-vars
                                        variation: o,
                                        // eslint-disable-next-line @typescript-eslint/no-unused-vars
                                        sendToRework: so,
                                        // eslint-disable-next-line @typescript-eslint/no-unused-vars
                                        categoryUpdated: cu,
                                        ..._document
                                    } = document;
                                    return {
                                        ..._document,
                                        documentId,
                                        categoryUpdated:
                                            initialValues.duplicationDocuments.some(
                                                (e, i) =>
                                                    d === i &&
                                                    e.category !==
                                                        document.category
                                            ),
                                        isMissingDocument: false,
                                    };
                                });
                        ManagePacketService.sendToRework({
                            documents: _documents
                                .concat(_documentsMissing)
                                .concat(_documentsDuplication),
                            clientId,
                            packetId,
                            categoryUpdated: _documents.some(
                                (e) => e.categoryUpdated === true
                            ),
                            solicitor: {
                                solicitorId: solicitor.solicitorId,
                                contactId: solicitor.contactId,
                                name: solicitor.name,
                            },
                            expiryDate: values.datepickerRework
                                ? createDateAsUTC(
                                      new Date(values.datepickerRework)
                                  ).toISOString()
                                : '',
                        })
                            .then((response) => {
                                setConfirmProceeding(false);
                                Utils.handleSuccessResponse(response);
                                SetSolicitorDisplayed(solicitor);
                                SetDetailSaved(true);
                                if (
                                    typeof callbackClosingModal === 'function'
                                ) {
                                    callbackClosingModal(null);
                                }
                            })
                            .catch((error) => {
                                setConfirmProceeding(false);
                                if (
                                    error !== null &&
                                    error instanceof AxiosError &&
                                    error.code === 'ERR_NETWORK'
                                ) {
                                    Toast.showErrorMessage(
                                        'No internet connection, Please try again!'
                                    );
                                } else {
                                    Utils.handleErrorResponse(error);
                                }
                            });
                    }
                } else {
                    setConfirmProceeding(false);
                }
            },
            [
                SolicitorsData,
                callbackClosingModal,
                clientId,
                initialValues.documents,
                initialValues.duplicationDocuments,
                packetId,
            ]
        );

        React.useEffect(() => {
            const fieldHelper = areWeTestingWithJest()
                ? { setValue: (test: any) => test }
                : getFieldHelpers('isReworkModal');
            if (open || areWeTestingWithJest()) {
                ClientService.getSolicitors({
                    clientId: (location.state as RawData).clientId,
                }).then((response: SolicitorsListResponse) => {
                    SetSolicitorsData(response.data.data);
                    SetSolicitors(
                        Array.from(response.data.data).map(
                            (element) => `${element.name} - ${element.email.id}`
                        )
                    );
                });
            }
            fieldHelper.setValue(open);
        }, [location.state, open]);

        React.useLayoutEffect(() => {
            const fieldHelper = getFieldHelpers('isReworkReason');
            fieldHelper.setValue(openDetailTextArea);
        }, [getFieldHelpers, openDetailTextArea]);

        // const handleChange = React.useCallback(
        //     (event: React.ChangeEvent<HTMLInputElement>) => {
        //         setOpenDetailTextArea(event.target.checked);
        //     },
        //     [openDetailTextArea]
        // );

        // const handleChangePredefinedMessage = React.useCallback(
        //     (event: any) => {
        //         const value =
        //             typeof event === 'string' ? event : event.target.value;

        //         switch (value) {
        //             case 'blurred':
        //                 setPredefinedMessage('Document blurred');
        //                 break;
        //             case 'wrong':
        //                 setPredefinedMessage('Document Wrong');
        //                 break;
        //             case 'cropped':
        //                 setPredefinedMessage('Document cropped');
        //                 break;
        //             case 'corrupted':
        //                 setPredefinedMessage('Document corrupted');
        //                 break;
        //             case 'datawrong':
        //                 setPredefinedMessage('Data / Information');
        //                 break;
        //             case 'other':
        //                 setPredefinedMessage('Other');
        //                 break;
        //             default:
        //                 break;
        //         }

        //         setPredefined(value);
        //     },
        //     []
        // );
        // React.useLayoutEffect(() => {
        //     const fieldHelper = getFieldHelpers('reworktext');
        //     fieldHelper.setValue(predefinedMessage);
        // }, [predefinedMessage]);

        React.useImperativeHandle(
            ref,
            () => ({
                setClose: () => {
                    handleClose();
                },
                setOpen: () => {
                    handleOpen();
                },
            }),
            [handleOpen, handleClose]
        );
        return (
            <Box>
                <Modal
                    disableEscapeKeyDown={isSaved}
                    open={open || areWeTestingWithJest()}
                    onClose={handleClose}
                    aria-labelledby="parent-modal-title"
                    aria-describedby="parent-modal-description"
                    disableScrollLock
                >
                    <Box className="container-document-modal-rework bulk-rework">
                        <Formik
                            innerRef={innerFormik}
                            validationSchema={NotExpectedPacketScheme}
                            initialValues={{
                                isReworkModal: true,
                                missingDocuments: missingDocuments ?? [],
                                solicitor: '',
                                datepickerRework,
                                documents: documents ?? [],
                                duplicationDocuments:
                                    duplicationDocuments ?? [],
                            }}
                            onSubmit={handleConfirm}
                        >
                            {({ handleSubmit }) => (
                                <>
                                    <AppFormikTextField
                                        name="isReworkModal"
                                        inputProps={{
                                            type: 'hidden',
                                        }}
                                        className="isReworkModal"
                                    />
                                    <AppFormikTextField
                                        name="isReworkReason"
                                        inputProps={{
                                            type: 'hidden',
                                        }}
                                        defaultValue={openDetailTextArea}
                                        className="isReworkReason"
                                    />
                                    <Typography
                                        variant="h2"
                                        id="parent-modal-title"
                                    >
                                        {isSaved
                                            ? `Rework requested successfully`
                                            : `Are you sure that you want to send these documents
                            for Rework?`}
                                    </Typography>

                                    {!isSaved && (
                                        <Box className="container-document-rework-detail">
                                            <Grid
                                                container
                                                spacing={2}
                                                className="categorise-container-selection"
                                            >
                                                <Grid
                                                    item
                                                    xs={8}
                                                    className="categorise-selection categorise-item"
                                                >
                                                    <InputLabel id="rework-selection-label">
                                                        Select a Reviewer
                                                    </InputLabel>
                                                    <AppFormikSelect
                                                        name="solicitor"
                                                        className="rework-selection"
                                                        notched={false}
                                                        labelId="fix-selection-label"
                                                        testid="solicitor-dropdown"
                                                        MenuProps={{
                                                            className:
                                                                'menu-fix-selection single-fix-rework',
                                                        }}
                                                        label="Reviewer"
                                                        items={Solicitors}
                                                    />
                                                </Grid>
                                                <Grid
                                                    item
                                                    xs={4}
                                                    className="dateselection categorise-item"
                                                >
                                                    <InputLabel id="rework-datepicker-label">
                                                        Expiry Date
                                                    </InputLabel>
                                                    <AppFormikDatePicker
                                                        name="datepickerRework"
                                                        disablePast
                                                        disableToday
                                                        disabled
                                                        className="datepicker-rework"
                                                        testid="datepicker-dropdown"
                                                        InputProps={{
                                                            name: 'datepickerRework',
                                                            'aria-labelledby':
                                                                'rework-datepicker-label',
                                                            notched: false,
                                                        }}
                                                        value={undefined}
                                                        // onChange={() => console.log('date')}
                                                        renderInput={(
                                                            props: any
                                                        ) => (
                                                            <TextField
                                                                {...props}
                                                            />
                                                        )}
                                                    />
                                                </Grid>
                                            </Grid>

                                            <FieldArray
                                                name="documents"
                                                render={() => (
                                                    <>
                                                        {Array.from(
                                                            documents ?? []
                                                        ).map(
                                                            (
                                                                element,
                                                                index: number
                                                            ) =>
                                                                element.sendToRework ? (
                                                                    <Grid
                                                                        key={
                                                                            index
                                                                        }
                                                                        container
                                                                        item
                                                                        className="send-solicitor-instruction  solicitor-detail-item"
                                                                        xs={12}
                                                                    >
                                                                        <FormControl id="reason-to-send-solicitor">
                                                                            <Grid
                                                                                container
                                                                                item
                                                                                xs={
                                                                                    12
                                                                                }
                                                                                spacing={
                                                                                    0
                                                                                }
                                                                                className="send-solicitor-container"
                                                                            >
                                                                                <Grid
                                                                                    item
                                                                                    xs={
                                                                                        12
                                                                                    }
                                                                                    sm={
                                                                                        12
                                                                                    }
                                                                                    md={
                                                                                        4
                                                                                    }
                                                                                    lg={
                                                                                        3
                                                                                    }
                                                                                >
                                                                                    <Stack
                                                                                        direction="row"
                                                                                        display="flex"
                                                                                        alignItems="center"
                                                                                    >
                                                                                        <Box
                                                                                            marginLeft={
                                                                                                2
                                                                                            }
                                                                                        >
                                                                                            <FormLabel id="checkbox-for-solicitor-instruction">
                                                                                                Select
                                                                                                the
                                                                                                reason
                                                                                            </FormLabel>
                                                                                            <FormGroup>
                                                                                                <AppFormikTextField
                                                                                                    name={`documents[${index}].sendToRework`}
                                                                                                    inputProps={{
                                                                                                        type: 'hidden',
                                                                                                    }}
                                                                                                    className="isFirstDocument"
                                                                                                />
                                                                                            </FormGroup>
                                                                                        </Box>
                                                                                        <Box>
                                                                                            <Typography variant="h5">
                                                                                                Category:
                                                                                                <strong>
                                                                                                    {` ${element.category}`}
                                                                                                </strong>
                                                                                            </Typography>
                                                                                            <Typography variant="h6">
                                                                                                {
                                                                                                    element.placeholder
                                                                                                }
                                                                                            </Typography>
                                                                                        </Box>
                                                                                    </Stack>
                                                                                </Grid>
                                                                                <Grid
                                                                                    item
                                                                                    xs={
                                                                                        12
                                                                                    }
                                                                                    md={
                                                                                        3
                                                                                    }
                                                                                    lg={
                                                                                        3
                                                                                    }
                                                                                    className="textarea-solicitor"
                                                                                >
                                                                                    <AppFormikSelect
                                                                                        testid="firstReasonPreDefined"
                                                                                        name={`documents[${index}].predefinedMessage`}
                                                                                        notched={
                                                                                            false
                                                                                        }
                                                                                        labelId="firstReasonPreDefined-label"
                                                                                        MenuProps={{
                                                                                            className:
                                                                                                'menu-fix-selection footer-document-viewer',
                                                                                        }}
                                                                                        placeholder="Select predefined reason"
                                                                                        label="Predefined reason"
                                                                                        items={[
                                                                                            'Document blurred',
                                                                                            'Document cropped',
                                                                                            'Data / Information',
                                                                                            'Document Wrong',
                                                                                            'Document corrupted',
                                                                                            'Document missing',
                                                                                            'Other',
                                                                                        ]}
                                                                                    />
                                                                                </Grid>
                                                                                <Grid
                                                                                    item
                                                                                    xs={
                                                                                        12
                                                                                    }
                                                                                    md={
                                                                                        5
                                                                                    }
                                                                                    lg={
                                                                                        6
                                                                                    }
                                                                                    className="textarea-solicitor"
                                                                                >
                                                                                    <AppFormikTextArea
                                                                                        disabled={
                                                                                            false
                                                                                        }
                                                                                        notched={
                                                                                            false
                                                                                        }
                                                                                        maxLength={
                                                                                            500
                                                                                        }
                                                                                        name={`documents[${index}].statusMessage`}
                                                                                        label="Write a message / Instructions"
                                                                                        // placeholder="Message for solicitor explaining what should be reworked"
                                                                                        rows={
                                                                                            1
                                                                                        }
                                                                                        testid="document-first-reason"
                                                                                        focused
                                                                                    />
                                                                                </Grid>
                                                                            </Grid>
                                                                        </FormControl>
                                                                    </Grid>
                                                                ) : null
                                                        )}
                                                    </>
                                                )}
                                            />

                                            <FieldArray
                                                name="duplicationDocuments"
                                                render={() => (
                                                    <>
                                                        {Array.from(
                                                            duplicationDocuments ??
                                                                []
                                                        ).map(
                                                            (
                                                                element,
                                                                index: number
                                                            ) =>
                                                                element.sendToRework ? (
                                                                    <Grid
                                                                        key={
                                                                            index
                                                                        }
                                                                        container
                                                                        item
                                                                        className="send-solicitor-instruction  solicitor-detail-item"
                                                                        xs={12}
                                                                    >
                                                                        <FormControl id="reason-to-send-solicitor">
                                                                            <Grid
                                                                                container
                                                                                item
                                                                                xs={
                                                                                    12
                                                                                }
                                                                                spacing={
                                                                                    0
                                                                                }
                                                                                className="send-solicitor-container"
                                                                            >
                                                                                <Grid
                                                                                    item
                                                                                    xs={
                                                                                        12
                                                                                    }
                                                                                    sm={
                                                                                        12
                                                                                    }
                                                                                    md={
                                                                                        4
                                                                                    }
                                                                                    lg={
                                                                                        3
                                                                                    }
                                                                                >
                                                                                    <Stack
                                                                                        direction="row"
                                                                                        display="flex"
                                                                                        alignItems="center"
                                                                                    >
                                                                                        <Box
                                                                                            marginLeft={
                                                                                                2
                                                                                            }
                                                                                        >
                                                                                            <FormLabel id="checkbox-for-solicitor-instruction">
                                                                                                Select
                                                                                                the
                                                                                                reason
                                                                                            </FormLabel>
                                                                                            <FormGroup>
                                                                                                <AppFormikTextField
                                                                                                    name={`duplicationDocuments[${index}].sendToRework`}
                                                                                                    inputProps={{
                                                                                                        type: 'hidden',
                                                                                                    }}
                                                                                                    className="isFirstDocument"
                                                                                                />
                                                                                            </FormGroup>
                                                                                        </Box>
                                                                                        <Box>
                                                                                            <Typography variant="h5">
                                                                                                Category:
                                                                                                <strong>
                                                                                                    {` ${element.category}`}
                                                                                                </strong>
                                                                                            </Typography>
                                                                                            <Typography variant="h6">
                                                                                                {
                                                                                                    element.placeholder
                                                                                                }
                                                                                            </Typography>
                                                                                        </Box>
                                                                                    </Stack>
                                                                                </Grid>
                                                                                <Grid
                                                                                    item
                                                                                    xs={
                                                                                        12
                                                                                    }
                                                                                    md={
                                                                                        3
                                                                                    }
                                                                                    lg={
                                                                                        3
                                                                                    }
                                                                                    className="textarea-solicitor"
                                                                                >
                                                                                    <AppFormikSelect
                                                                                        testid="firstReasonPreDefined"
                                                                                        name={`duplicationDocuments[${index}].predefinedMessage`}
                                                                                        notched={
                                                                                            false
                                                                                        }
                                                                                        labelId="firstReasonPreDefined-label"
                                                                                        MenuProps={{
                                                                                            className:
                                                                                                'menu-fix-selection footer-document-viewer',
                                                                                        }}
                                                                                        placeholder="Select predefined reason"
                                                                                        label="Predefined reason"
                                                                                        items={[
                                                                                            'Document blurred',
                                                                                            'Document cropped',
                                                                                            'Data / Information',
                                                                                            'Document Wrong',
                                                                                            'Document corrupted',
                                                                                            'Document missing',
                                                                                            'Other',
                                                                                        ]}
                                                                                    />
                                                                                </Grid>
                                                                                <Grid
                                                                                    item
                                                                                    xs={
                                                                                        12
                                                                                    }
                                                                                    md={
                                                                                        5
                                                                                    }
                                                                                    lg={
                                                                                        6
                                                                                    }
                                                                                    className="textarea-solicitor"
                                                                                >
                                                                                    <AppFormikTextArea
                                                                                        disabled={
                                                                                            false
                                                                                        }
                                                                                        notched={
                                                                                            false
                                                                                        }
                                                                                        maxLength={
                                                                                            500
                                                                                        }
                                                                                        name={`duplicationDocuments[${index}].statusMessage`}
                                                                                        label="Write a message / Instructions"
                                                                                        // placeholder="Message for solicitor explaining what should be reworked"
                                                                                        rows={
                                                                                            1
                                                                                        }
                                                                                        testid="document-first-reason"
                                                                                        focused
                                                                                    />
                                                                                </Grid>
                                                                            </Grid>
                                                                        </FormControl>
                                                                    </Grid>
                                                                ) : null
                                                        )}
                                                    </>
                                                )}
                                            />

                                            <FieldArray
                                                name="missingDocuments"
                                                render={() => (
                                                    <>
                                                        {Array.from(
                                                            missingDocuments ??
                                                                []
                                                        ).map(
                                                            (
                                                                element,
                                                                index: number
                                                            ) =>
                                                                element.sendToRework ? (
                                                                    <Grid
                                                                        key={
                                                                            index
                                                                        }
                                                                        container
                                                                        item
                                                                        className="send-solicitor-instruction  solicitor-detail-item"
                                                                        xs={12}
                                                                    >
                                                                        <FormControl id="reason-to-send-solicitor">
                                                                            <Grid
                                                                                container
                                                                                item
                                                                                xs={
                                                                                    12
                                                                                }
                                                                                spacing={
                                                                                    0
                                                                                }
                                                                                className="send-solicitor-container"
                                                                            >
                                                                                <Grid
                                                                                    item
                                                                                    xs={
                                                                                        12
                                                                                    }
                                                                                    sm={
                                                                                        12
                                                                                    }
                                                                                    md={
                                                                                        4
                                                                                    }
                                                                                    lg={
                                                                                        3
                                                                                    }
                                                                                >
                                                                                    <Stack
                                                                                        direction="row"
                                                                                        display="flex"
                                                                                        alignItems="center"
                                                                                    >
                                                                                        <Box
                                                                                            marginLeft={
                                                                                                2
                                                                                            }
                                                                                        >
                                                                                            <FormLabel id="checkbox-for-solicitor-instruction">
                                                                                                Select
                                                                                                the
                                                                                                reason
                                                                                            </FormLabel>
                                                                                            <FormGroup>
                                                                                                <AppFormikTextField
                                                                                                    name={`missingDocuments[${index}].sendToRework`}
                                                                                                    inputProps={{
                                                                                                        type: 'hidden',
                                                                                                    }}
                                                                                                    className="isFirstDocument"
                                                                                                />
                                                                                            </FormGroup>
                                                                                        </Box>
                                                                                        <Box>
                                                                                            <Typography variant="h5">
                                                                                                Category:
                                                                                                <strong>
                                                                                                    {` ${element.category}`}
                                                                                                </strong>
                                                                                            </Typography>
                                                                                            <Typography variant="h6">
                                                                                                {
                                                                                                    element.placeholder
                                                                                                }
                                                                                            </Typography>
                                                                                        </Box>
                                                                                    </Stack>
                                                                                </Grid>
                                                                                <Grid
                                                                                    item
                                                                                    xs={
                                                                                        12
                                                                                    }
                                                                                    md={
                                                                                        3
                                                                                    }
                                                                                    lg={
                                                                                        3
                                                                                    }
                                                                                    className="textarea-solicitor"
                                                                                >
                                                                                    <AppFormikSelect
                                                                                        testid="firstReasonPreDefined"
                                                                                        name={`missingDocuments[${index}].predefinedMessage`}
                                                                                        notched={
                                                                                            false
                                                                                        }
                                                                                        labelId="firstReasonPreDefined-label"
                                                                                        MenuProps={{
                                                                                            className:
                                                                                                'menu-fix-selection footer-document-viewer',
                                                                                        }}
                                                                                        placeholder="Select predefined reason"
                                                                                        label="Predefined reason"
                                                                                        items={[
                                                                                            'Document blurred',
                                                                                            'Document cropped',
                                                                                            'Data / Information',
                                                                                            'Document Wrong',
                                                                                            'Document corrupted',
                                                                                            'Document missing',
                                                                                            'Other',
                                                                                        ]}
                                                                                    />
                                                                                </Grid>
                                                                                <Grid
                                                                                    item
                                                                                    xs={
                                                                                        12
                                                                                    }
                                                                                    md={
                                                                                        5
                                                                                    }
                                                                                    lg={
                                                                                        6
                                                                                    }
                                                                                    className="textarea-solicitor"
                                                                                >
                                                                                    <AppFormikTextArea
                                                                                        disabled={
                                                                                            false
                                                                                        }
                                                                                        notched={
                                                                                            false
                                                                                        }
                                                                                        maxLength={
                                                                                            500
                                                                                        }
                                                                                        name={`missingDocuments[${index}].statusMessage`}
                                                                                        label="Write a message / Instructions"
                                                                                        // placeholder="Message for solicitor explaining what should be reworked"
                                                                                        rows={
                                                                                            1
                                                                                        }
                                                                                        testid="document-first-reason"
                                                                                        focused
                                                                                    />
                                                                                </Grid>
                                                                            </Grid>
                                                                        </FormControl>
                                                                    </Grid>
                                                                ) : null
                                                        )}
                                                    </>
                                                )}
                                            />
                                        </Box>
                                    )}
                                    {isSaved && (
                                        <Box className="container-document-rework-detail-saved">
                                            <Typography className="solicitorname">{`${SolicitorDisplayed?.name} (${SolicitorDisplayed?.email.id})`}</Typography>
                                            <Typography>
                                                had received an email requesting
                                                to
                                            </Typography>
                                            <Typography>
                                                re upload the documents below:
                                            </Typography>
                                            <ul>
                                                {documents
                                                    ?.concat(
                                                        Array.from(
                                                            missingDocuments ??
                                                                []
                                                        )
                                                    )
                                                    ?.filter(
                                                        (d) =>
                                                            d.sendToRework ===
                                                            true
                                                    )
                                                    ?.map((e) => (
                                                        <li>{`${
                                                            e.placeholder
                                                                ? e.placeholder
                                                                : e.category
                                                        }`}</li>
                                                    ))}
                                            </ul>
                                        </Box>
                                    )}
                                    {!isSaved ? (
                                        <Box className="action-to-complete-task-rework">
                                            <Grid
                                                container
                                                spacing={2}
                                                className="action-container-complete-task"
                                            >
                                                <Grid
                                                    item
                                                    xs={6}
                                                    className="action-item"
                                                >
                                                    <AppPrimaryButton
                                                        title="Go back"
                                                        className="btn-small back"
                                                        onClick={handleClose}
                                                    />
                                                </Grid>
                                                <Grid
                                                    item
                                                    xs={6}
                                                    className="action-item"
                                                >
                                                    <AppPrimaryButton
                                                        title="Confirm & Proceed"
                                                        className="btn-small"
                                                        onClick={handleSubmit}
                                                        disabled={
                                                            isConfirmProceeding
                                                        }
                                                    />
                                                </Grid>
                                            </Grid>
                                        </Box>
                                    ) : (
                                        <Box className="action-to-close-task-rework">
                                            <AppPrimaryButton
                                                title="Go back"
                                                className="btn-small back"
                                                disabled={
                                                    NotExpectedMetaProps?.isActiveBackNavigation
                                                }
                                                onClick={handleCloseRework}
                                            />
                                        </Box>
                                    )}
                                </>
                            )}
                        </Formik>
                    </Box>
                </Modal>
            </Box>
        );
    }
);

export default ReworkBulkModal;
